import type { pianoHandlers } from '@/app_lib/services/Piano/pianoHandlers';
import type { PaywallState } from '@/app_lib/types/accounts/piano/Paywall';
import type { PageType } from '@/app_lib/types/Post';

export interface TemplateParams {
  additionalParamNames: string[];
  affiliateState: {
    issuerId: string;
    userId: string;
  };
  browserId: string;
  containerSelector: string;
  displayMode: string;
  experienceId: string;
  experienceActionId: string;
  iframeUrl: string;
  postMessageUrl: string;
  showCloseButton: boolean;
  templateId: string;
  templateVariantId: string | null;
  trackingId: string;
  widget: string;
}

export interface ExperienceEvent {
  result: {
    events: {
      eventExecutionContext: {
        countryCode: string;
      };
    }[];
  };
}

export interface LinkedTerm {
  linkedTermData: {
    externalTermId: string;
  };
}

export interface PianoPageConfig {
  contentSection: string;
  franchiseWall: boolean;
  pageType: PageType;
  publishDate: string;
  tags: string[];
}

export enum PianoConfig {
  BypassSection = 'Editorial Bypass',
}

export interface ResponseVariables {
  paywall30: PaywallState;
  hideOutbrain: boolean;
  hideInStreamAds: boolean;
  stopVideoDock: boolean;
  showPaywallax: boolean;
}

export interface OfferParams {
  containerSelector: string;
  displayMode: string;
  offerId: string;
  experienceActionId: string;
  experienceId: string;
  templateId: string;
  templateVariantId: string;
}

export interface ResponseVariableEvent {
  responseVariables: Partial<ResponseVariables>;
}

export interface CustomEvent {
  eventName:
    | 'subscriptionResume'
    | 'passwordlessClose'
    | 'passwordlessLogin'
    | 'newsletterSubscribe'
    | 'passwordlessRegister';
  params?: {
    email: string;
    params: string;
    country?: string;
    formname?: string;
    registrationconsent?: string;
    consent?: string;
  };
}

export interface LoginDataProps {
  registration: boolean;
  source: string;
  params: {
    confirmed: boolean;
    // biome-ignore lint/style/useNamingConvention: <external data>
    email_confirmation_required: boolean;
  };
}

export interface Params {
  aid: string;
  displayMode: string;
  experienceActionId: string;
  experienceExecutionId: string;
  experienceId: string;
  iframeId: string;
  offerId: string;
  tags: string;
  templateId: string;
  trackingId: string;
  url: string;
  width: number;
}

export interface CheckoutCustomEvent {
  eventName: string;
  state: string;
  stateName?: string;
  params: {
    method?: string;
    termId?: string;
  };
}

export interface Term {
  name: string;
  currency: string;
  price: number | string;
  description: string;
  id: string;
}

export interface OfferTerms {
  [key: string]: Term;
}

export interface TermDetailsProps {
  termName: string;
  termId: string;
}

export type SetterMap = {
  [K in keyof ResponseVariables]: React.Dispatch<React.SetStateAction<ResponseVariables[K]>>;
};

export type PianoHandlers = ReturnType<typeof pianoHandlers>;
export type PianoHandler = PianoHandlers[keyof PianoHandlers];

export type RegistrationSource =
  | 'paywall'
  | 'registration_wall'
  | 'sign_in_popup'
  | 'checkout_flow'
  | 'newsletter_template'
  | 'google_one_tap'
  | 'sign_in_flow';
